import React, {useState} from 'react';
import {
    Modal,
    ModalBody,
    Button, Row, Col, ModalHeader
} from 'reactstrap';
import {ChevronLeft, ChevronRight, X} from 'lucide-react';


const Gallery = (props) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const openModal = (index) => {
        setSelectedIndex(index);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedIndex(null);
    };

    const nextImage = () => {
        setSelectedIndex((prev) => (prev + 1) % props.images.length);
    };

    const prevImage = () => {
        setSelectedIndex((prev) => (prev - 1 + props.images.length) % props.images.length);
    };

    return (
        <div className="gallery-container p-4">
            <Row className="g-1" >
                {props.images.map((img, idx) => (
                    <Col md={3} style={{height: "30vh"}}>
                        <img
                            key={idx}
                            src={img}
                            alt={`img-${idx}`}
                            onClick={() => openModal(idx)}
                            //className="masonry-img"
                            style={{height:'100%',width:'100%',cursor:'pointer'}}
                        />
                    </Col>
                ))}
            </Row>

            <Modal
                isOpen={modalOpen}
                toggle={closeModal}
                centered
                size="xl"
                fade
                className="custom-modal"
            >

                <ModalBody className="position-relative p-0 bg-dark">
                    <Button

                        onClick={closeModal}
                        className="position-absolute text-white"
                        style={{top: 15, right: 20, fontSize: '1.5rem', zIndex: 10}}
                    >
                        <X/>
                    </Button>

                    <Button
                        color="link"
                        onClick={prevImage}
                        className="position-absolute text-white"
                        style={{top: '50%', left: 20, transform: 'translateY(-50%)', zIndex: 10}}
                    >
                        <ChevronLeft size={40}/>
                    </Button>

                    {selectedIndex !== null && (
                        <img
                            src={props.images[selectedIndex]}
                            alt="Selected"
                            className="img-fluid"
                            style={{
                                maxHeight: '70vh',
                                maxWidth: '90%',
                                margin: 'auto',
                                display: 'block',
                                borderRadius: '8px',
                            }}
                        />
                    )}

                    <Button
                        color="link"
                        onClick={nextImage}
                        className="position-absolute text-white"
                        style={{top: '50%', right: 20, transform: 'translateY(-50%)', zIndex: 10}}
                    >
                        <ChevronRight size={40}/>
                    </Button>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default Gallery;
